/**
 * 设备管理
 * **/

const productApi = {
  //获取列表
  getList: '/ProductType/GetList',
  //获取信息
  getInfo: '/ProductType/GetInfo',
  //添加
  add: '/ProductType/Add',
  //修改
  edit: '/ProductType/Edit',
  //删除
  delete: '/ProductType/Del',
}

export default productApi
